var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsameLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 176,
    fill: "url(#paint0_linear_202_3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M769.175 452.118L370.579 451.678C339.658 451.685 310.006 463.963 288.144 485.812C266.282 507.662 254 537.294 254 568.19V798.71C254 807.537 257.509 816.004 263.755 822.247C270.002 828.49 278.474 831.998 287.308 832H652.94C683.864 831.998 713.52 819.722 735.386 797.872C757.252 776.022 769.536 746.388 769.536 715.488L770 459.631V423.853C769.788 376.523 755.149 330.382 728.034 291.575C700.919 252.767 662.614 223.136 618.222 206.627C573.83 190.118 525.458 187.516 479.548 199.167C433.639 210.817 392.372 236.168 361.243 271.842",
    stroke: "white",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.001 692C539.615 692 562.001 669.614 562.001 642C562.001 614.386 539.615 592 512.001 592C484.387 592 462.001 614.386 462.001 642C462.001 669.614 484.387 692 512.001 692Z",
    stroke: "white",
    strokeWidth: 32
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_3",
    x1: 0,
    y1: 0,
    x2: 1024,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006DE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsameLight);
export default __webpack_public_path__ + "static/media/SésameLight.231714273c8016e260d8ccccbf4f3443.svg";
export { ForwardRef as ReactComponent };